import * as React from 'react'

function SvgIconOpenSource(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="open-source" aria-labelledby="t-open-source d-open-source">
        <title id="t-open-source">{'Open Source'}</title>
        <desc id="d-open-source">{'Open Source'}</desc>
        <path d="M16 1c8.284 0 15 6.716 15 15 0 6.115-3.659 11.375-8.907 13.711l-3.265-8.418A6.002 6.002 0 0016 10a6 6 0 00-2.828 11.293l-3.265 8.418C4.659 27.375 1 22.115 1 16 1 7.716 7.716 1 16 1m0-1C7.178 0 0 7.178 0 16a16.025 16.025 0 009.5 14.625 1.008 1.008 0 00.788.011 1 1 0 00.551-.563l3.265-8.418a1 1 0 00-.46-1.243A5 5 0 0116 11c2.757 0 5 2.243 5 5a5.002 5.002 0 01-2.645 4.412.999.999 0 00-.46 1.242l3.265 8.418a1.001 1.001 0 001.339.552A16.022 16.022 0 0032 16c0-8.822-7.178-16-16-16z" />
      </g>
    </svg>
  )
}

export default SvgIconOpenSource
